import { styled } from '@linaria/react';

import { colors, fonts, layout, semantic, space } from '../../theme/tokens';

export const Panel = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${space[4]};
  padding: ${space[6]} ${space[5]} ${space[5]};
`;

export const HeadingBlock = styled.div`
  text-align: center;
  margin-bottom: var(--voyager-signin-header-gap, 0);
`;

export const Heading = styled.h2`
  font-family: ${fonts.heading};
  font-size: var(--voyager-signin-heading-size, ${fonts.size.xl});
  font-weight: var(--voyager-signin-heading-weight, ${fonts.weight.bold});
  color: ${semantic.text.primary};
  margin: 0;
  line-height: 1.2;
  letter-spacing: var(--voyager-signin-heading-tracking, normal);
`;

export const HeadingAccent = styled.span`
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.secondary};
`;

export const SignUpRow = styled.p`
  font-family: ${fonts.body};
  font-size: var(--voyager-signin-subtitle-size, ${fonts.size.sm});
  color: ${semantic.text.primary};
  margin: var(--voyager-signin-title-gap, ${space[2]}) 0 0;
  text-align: center;
`;

export const InlineLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  font: inherit;
  color: ${semantic.text.primary};
  text-decoration: underline;

  &:hover {
    text-decoration: none;
  }
`;

export const FormBlock = styled.form`
  display: flex;
  flex-direction: column;
  gap: var(--voyager-signin-form-gap, ${space[3]});
`;

export const InsetField = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[1]};
`;

export const ForgotRow = styled.div`
  text-align: center;
  margin-top: ${space[2]};
`;

export const CloseButton = styled.button`
  position: absolute;
  top: ${space[3]};
  right: ${space[3]};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${space[2]};
  border: none;
  border-radius: ${layout.borderRadiusFull};
  background: none;
  color: ${semantic.icon.primary};
  line-height: 1;
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover {
    background: ${semantic.bg.surfaceSubtle};
  }

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }
`;

export const FormError = styled.div`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  color: ${semantic.text.danger};
  text-align: center;
`;
